import React from "react";
import "./PageLoader.css";

const PageLoader = () => {
  return (
    <div className="page-loader-wrapper">
      <div className="page-loader-dots">
        <div className="page-loader-dot"></div>
        <div className="page-loader-dot"></div>
        <div className="page-loader-dot"></div>
      </div>
    </div>
  );
};

export default PageLoader;
